import { Button, Heading, RefreshIcon, Stack, Text } from '@lmc/design-system'
import { cssVars } from '@lmc/design-system/tokens'
import { NAMESPACE } from 'locale'
import { carePlansConstants } from 'locale/carePlans'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const { color, font, fontWeight, spacing, text } = cssVars

const Wrapper = styled.div`
  max-width: 528px;
  margin: 0 auto;
  padding: ${spacing['600']} ${spacing['200']};

  /*
   * The app's legacy element styles (h1, p, button) are unlayered, so they beat the
   * design system's layered utilities. Re-apply the design-system tokens here until
   * the legacy CSS moves into a cascade layer.
   */
  h1 {
    margin: 0;
    font-size: ${text.heading.lg.size};
    line-height: ${text.heading.lg.lineHeight};
    font-weight: ${fontWeight.semibold};
    color: ${color.text.primary};
  }

  p {
    color: ${color.text.primary};
  }

  button {
    font-family: ${font.body};
    font-size: ${text.body.md.size};
    line-height: ${text.body.md.lineHeight};
    font-weight: ${fontWeight.medium};
    color: ${color.text.action.inverse.default};
  }
`

type CarePlanLoadErrorProps = {
  onRetry: () => void
}

const CarePlanLoadError = ({ onRetry }: CarePlanLoadErrorProps) => {
  const { t } = useTranslation(NAMESPACE.CARE_PLANS)

  return (
    <Wrapper role="alert">
      <Stack gap="200" align="center">
        <Heading as="h1" size="lg" align="center">
          {t(carePlansConstants.LOAD_ERROR_TITLE)}
        </Heading>
        <Stack gap="50" align="center">
          <Text align="center">
            {t(carePlansConstants.LOAD_ERROR_RETRY_HINT)}
          </Text>
          <Text align="center">
            {t(carePlansConstants.LOAD_ERROR_CONTACT_HINT)}
          </Text>
        </Stack>
        <Button icon={<RefreshIcon size={16} />} onClick={() => onRetry()}>
          {t(carePlansConstants.LOAD_ERROR_REFRESH)}
        </Button>
      </Stack>
    </Wrapper>
  )
}

export default CarePlanLoadError
